
































import Vue from 'vue';
import * as utils from '@/lib/utils';
import { mapState, mapMutations } from 'vuex';

const stopIcon = require('@/assets/stop_icons/stop.svg') as string;
const pickupIcon = require('@/assets/stop_icons/pickup.svg') as string;
const dropoffIcon = require('@/assets/stop_icons/dropoff.svg') as string;

const busIconRed = require('@/assets/bus_icons/bus_red_1.svg') as string;
const busIconBlue = require('@/assets/bus_icons/bus_blue_1.svg') as string;
const busIconGreen = require('@/assets/bus_icons/bus_green_1.svg') as string;
const busIconPurple = require('@/assets/bus_icons/bus_purple_1.svg') as string;
const busIconYellow = require('@/assets/bus_icons/bus_yellow_1.svg') as string;
const busIconGrey = require('@/assets/bus_icons/bus_grey_1.svg') as string;
const busIconOrange = require('@/assets/bus_icons/bus_orange_1.svg') as string;

export default Vue.extend({
    name: 'RidesMap',
    props: {
        ongoingRidesData: {
            type: Array,
        },
        routesPathsData: {
            type: Array,
        },
        ridesStops: {
            type: Array,
        },
    },
    computed: {
        ...mapState('offices', ['corpOffices']),
    },
    data() {
        return {
            ROUTES_COLORS: ['blue', 'purple', 'green', '#E53935', '#FBC02D', '#546E7A', '#D84315'],
            BUS_ICONS: [busIconBlue, busIconPurple, busIconGreen, busIconRed, busIconYellow, busIconGrey, busIconOrange],
            center: { lat: 0, lng: 0 } as object,
            rideBusLocations: [] as Array<object>,
            stopsLocations: [] as Array<object>,
            routesPaths: [] as Array<object>,
            mapOptions: {
                zoomControl: true,
                mapTypeControl: true,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
                disableDefaultUi: false,
            },
            infoWindowPos: null as any,
            infoWinOpen: false,
            infoOptions: {
                content: '',
                // optional: offset infowindow so it visually sits nicely on top of our marker
                pixelOffset: {
                    width: 0,
                    height: -35,
                },
            },
            currentMidx: null,
            rideIdIconMap: new Map<number, string>(),
            bounds: null as any,
        };
    },
    mounted() {
        this.updateVehicleLocation();
        this.updateRoutesPaths();
        this.setStopsAndOffices();
    },
    watch: {
        ongoingRidesData: {
            deep: true,
            handler() {
                this.updateVehicleLocation();
            },
        },
        routesPathsData: {
            deep: true,
            handler() {
                this.updateRoutesPaths();
            },
        },
        ridesStops: {
            deep: true,
            handler(val: any, oldVal: any) {
                // vue dont really compares values when refs change - we have to do it ourselves
                if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
                    this.setStopsAndOffices();
                }
            },
        },
    },
    methods: {
        ...mapMutations('offices', ['setOffices']),
        selectRoutePath(route: any, e: any) {
            const [coordinates, routeName] = route;
            this.infoWindowPos = {
                lat: e.latLng.lat(),
                lng: e.latLng.lng(),
            };
            this.infoOptions.content = routeName;
            this.infoOptions.pixelOffset = {
                width: 0,
                height: 0,
            };
            this.infoWinOpen = true;
        },

        // needs bus location
        updateRoutesPaths() {
            const routesPathsData = JSON.parse(JSON.stringify(this.routesPathsData));

            // pacman cut geojson line of parts that the bus already moved
            routesPathsData.forEach((line: any) => {
                // take bus location of that ride line
                const busMarker = this.ongoingRidesData.find((m: any) => m.rideId === line.rideId) as any;
                if (!busMarker) { return; }
                const busLocation = busMarker.vehicleLocationData;

                // open json to get the line coords
                const linePathJson = JSON.parse(line.path);
                const routeCoords = linePathJson.features[0].geometry.coordinates;

                // cut accoring to bus location and stringify back from json
                linePathJson.features[0].geometry.coordinates = this.cutLinePartThatsBeforePoint(routeCoords, busLocation);
                line.path = JSON.stringify(linePathJson);
            });

            // draw line on the map
            this.routesPaths = routesPathsData.map((route: any) => {
                if (route.path) {
                    return [
                        JSON.parse(route.path).features[0].geometry.coordinates.map((coordinate: any) => ({
                            lat: Number(coordinate[1]),
                            lng: Number(coordinate[0]),
                        })),
                        route.routeName,
                        route.rideId,
                    ];
                }
                return [];
            });
        },

        // point has { lat, long } keys, and line has just 2 numbers array [longitude, latitude]
        // remember: latitude going from North to South and comes first (N)
        // and longitude is going from east to west and comes second (E)
        cutLinePartThatsBeforePoint(line: any, point: any) {
            if (!line || line.length < 2) { return []; }

            let minDist = Number.MAX_VALUE;
            let minIdx = 0;
            for (let idx = 0; idx < line.length; idx++) {
                const dist = utils.locationDistance(
                    { lat: line[idx][1], long: line[idx][0] },
                    { lat: Number(point.lat), long: Number(point.long) },
                );

                if (dist < minDist) {
                    minDist = dist;
                    minIdx = idx;
                }
            }

            return line.splice(minIdx);
        },

        async setAllOffices() {
            if (this.corpOffices.length === 0) {
                try {
                    const offices = await this.$hipApi.getAllCorpOffices();
                    this.setOffices({ offices });

                } catch (err) {
                    this.$notifier.showError(err?.error?.message || err?.message || err);
                }
            }

            // update offices only once - they dont change
            this.corpOffices.forEach((stop: any) => {
                const pickupLat = stop?.pickupStopLat;
                const pickupLong = stop?.pickupStopLong;
                if (pickupLat && pickupLong) {
                    this.addStopLocation(pickupLat, pickupLong, stop.pickupStopName, pickupIcon, 3);
                    this.bounds.extend({
                        lat: Number(pickupLat),
                        lng: Number(pickupLong),
                    });
                }
                const dropoffStopLat = stop?.dropoffStopLat;
                const dropoffStopLong = stop?.dropoffStopLong;
                if (dropoffStopLat && dropoffStopLong) {
                    this.addStopLocation(dropoffStopLat, dropoffStopLong, stop.dropoffStopName, dropoffIcon, 3);
                    this.bounds.extend({
                        lat: Number(dropoffStopLat),
                        lng: Number(dropoffStopLong),
                    });
                }
            });
        },
        async setAllStops() {
            this.ridesStops.forEach((stops: any) => {
                stops.forEach((stop: any) => {
                    if (stop.stopLat && stop.stopName) {
                        this.addStopLocation(stop.stopLat, stop.stopLong, stop.stopName, stopIcon, 2);
                        this.bounds.extend({
                            lat: Number(stop.stopLat),
                            lng: Number(stop.stopLong),
                        });
                    }
                });
            });
        },
        setStopsAndOffices() {
            // @ts-ignore
            this.$refs.gmap.$mapPromise.then(async (map: any) => {
                // @ts-ignore
                // eslint-disable-next-line
                this.bounds = new google.maps.LatLngBounds();
                this.stopsLocations = []; // stops on map

                // ride stops
                await this.setAllStops();

                // offices stops
                await this.setAllOffices();

                // fit to bounds of all stops
                map.fitBounds(this.bounds);
            });
        },
        addStopLocation(lat: string, lng: string, stopName: string, icon: string, zindex: number) {
            const marker = {
                lat: Number(lat),
                lng: Number(lng),
            };
            this.stopsLocations.push({
                position: marker,
                infoText: `<p>${stopName}</p>`,
                marker: {
                    icon: {
                        url: icon,
                        labelOrigin: { x: 20, y: -3 },
                        // @ts-ignore
                        // eslint-disable-next-line
                        scaledSize: new google.maps.Size(30, 30),
                    },
                },
                zindex,
            });
        },
        updateVehicleLocation() {
            this.rideBusLocations = [];
            this.ongoingRidesData.forEach((ride: any) => {
                if (ride.rideId === ride.vehicleLocationData.rideId) {
                    const lat = ride?.vehicleLocationData?.lat;
                    const long = ride?.vehicleLocationData?.long;
                    if (lat && long) {
                        this.addRideLocation(lat, long, ride);
                    }
                }
            });
        },
        toggleInfoWindow(marker: any, idx: any) {
            this.infoWindowPos = marker.position;
            this.infoOptions.content = marker.infoText;
            this.infoOptions.pixelOffset = {
                width: 0,
                height: -35,
            };

            // check if its the same marker that was selected if yes toggle
            if (this.currentMidx === idx) {
                this.infoWinOpen = !this.infoWinOpen;
            } else {
                // if different marker set infowindow to open and reset current marker index
                this.infoWinOpen = true;
                this.currentMidx = idx;
            }
        },
        addRideLocation(lat: string, lng: string, rideInfo: any): void {
            const marker = {
                lat: Number(lat),
                lng: Number(lng),
            };
            if (!this.rideIdIconMap.has(rideInfo.rideId)) {
                this.rideIdIconMap.set(rideInfo.rideId, this.BUS_ICONS[(rideInfo.rideId % 10) % this.ROUTES_COLORS.length] as string);
            }
            const rideStops = rideInfo.rideDetails?.extraDetails?.rideStops;
            if (rideStops && rideStops.length > 0) {
                this.rideBusLocations.push({
                    position: marker,
                    infoText: `<p>${rideInfo.rideDetails.routeName}</p><p>Planned Departure: ${rideInfo.rideDetails.plannedDeparture}</p><p>ETA: ${rideStops[rideStops.length - 1].estArrival}</p>
                                <p>Booked: ${parseInt(rideInfo.rideDetails.boardedPassengers) + parseInt(rideInfo.rideDetails.nonBoardedPassengers)}</p>
                                <p>Boarded: ${rideInfo.rideDetails.boardedPassengers}</p>`,
                    busMarker: {
                        icon: {
                            url: this.rideIdIconMap.get(rideInfo.rideId),
                            labelOrigin: { x: 20, y: -3 },
                        },
                        label: {
                            text: `${rideInfo.rideDetails.routeName}`,
                            color: '#000000',
                            fontWeight: 'bold',
                            fontSize: '12px',
                        },
                    },
                });
            }
        },
    },
});
